import gql from 'graphql-tag';

export const registerChipResellerQuery = gql`
  mutation registerChipResellerV2($input: RegisterChipResellerInputV2!) {
    registerChipResellerV2(input: $input) {
      id
      taxExemptType
    }
  }
`;
